export interface TabbedSearchActiveTabState {
  activeTabKey: string;
  activeTabValue: string;
  allTabs?: Record<string, string>;
}

// Enum for facet label keys
export enum FacetLabelsEnum {
  BUSINESS_UNIT = 'business-unit',
  PERSONAS = 'personas',
  PROGRAMS_SOLUTIONS = 'programs-solutions',
  CREATED_BY_DIVISION = 'created-by-division',
}

// Type for facet labels prop
export type FacetLabels = Partial<Record<FacetLabelsEnum, Record<string, string>>>;
